import api from "@/configs/axios-config";

export type RecalculateAllBody = {
  recalculate_child_parts: boolean;
};

export const recalculateAllPrices = async (data: RecalculateAllBody) => {
  const response = await api.post("/material-base-prices/recalculate-all", data);
  return response.data;
};

export const unlockApp = async () => {
  const response = await api.delete("/pubsub/lock-app");
  return response.data;
};
